import { render, staticRenderFns } from "./cbIcon.vue?vue&type=template&id=65a45935&"
import script from "./cbIcon.vue?vue&type=script&lang=js&"
export * from "./cbIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports